import React from 'react'
import { Field } from 'redux-form'
import { Col, Button } from 'react-bootstrap'
import Form from 'components/Form'
import CheckboxField from 'components/CheckboxField'
import PropTypes from 'prop-types'

export const ViewPersonal = ({ isBtnDisabled, ...props }) => {
	return <Col xs={12} md={4}>
		<h4>Visible Personal Information</h4>
		<Form shouldShowSuccessMessage {...props}>
			<Field
				id='gender'
				name='gender'
				label='Gender'
				component={CheckboxField}
			/>
			<Field
				id='age'
				name='age'
				label='Age'
				component={CheckboxField}
			/>
			<Field
				id='city'
				name='city'
				label='City'
				component={CheckboxField}
			/>
			<Field
				id='state'
				name='state'
				label='State'
				component={CheckboxField}
			/>
			<Field
				id='isMarried'
				name='isMarried'
				label='Marital status'
				component={CheckboxField}
			/>
			<Field
				id='hasChildren'
				name='hasChildren'
				label='Children'
				component={CheckboxField}
			/>
			<Field
				id='ethnicity'
				name='ethnicity'
				label='Ethnicity'
				component={CheckboxField}
			/>
			<Field
				id='religion'
				name='religion'
				label='Religion'
				component={CheckboxField}
			/>
			<Field
				id='politicalAffiliation'
				name='politicalAffiliation'
				label='Political affiliation'
				component={CheckboxField}
			/>
			<div className='mt mb'>
				<Button type='submit' bsStyle='primary' disabled={isBtnDisabled} title={isBtnDisabled ? 'Please select at least one option.' : null}>Save Changes</Button>
			</div>
		</Form>
	</Col>

}

ViewPersonal.propTypes = {
	isBtnDisabled: PropTypes.bool
}

export default ViewPersonal




// WEBPACK FOOTER //
// ./src/routes/Settings/components/ViewPersonal.js